import {
  JournalDraftEntryDetailSidepanelDocument,
  JournalDraftEntryDetailSidepanelQuery,
} from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import JournalEntryDetailContent from 'modules/finance/components/JournalEntryDetailContent'
import { mapTypeText } from 'modules/finance/lib/journalEntries'

interface Props {
  journalDraftEntryId: number
  companyId: number
  onClose: () => void
}

const JournalDraftEntryDetailSidepanel = ({ journalDraftEntryId, companyId, onClose }: Props) => {
  const { data, loading } = useQuery<
    JournalDraftEntryDetailSidepanelQuery,
    { id: number; companyId: number }
  >(JournalDraftEntryDetailSidepanelDocument, {
    variables: {
      id: Number(journalDraftEntryId),
      companyId: companyId,
    },
  })

  const journalType = data?.finance.journalDraftEntry?.type

  return (
    <Sidepanel
      title={i18n.t('finance.journal_entry.detail.title_draft_v2', {
        type: journalType ? mapTypeText(journalType) : '',
      })}
      footer={null}
      width="wideXL"
      closeLabel={i18n.t('common.close')}
      onClose={onClose}
      overlay
      boxPadding
      open
      headerBorder
      locked
    >
      <JournalEntryDetailContent data={data} loading={loading} onClose={onClose} />
    </Sidepanel>
  )
}

export default JournalDraftEntryDetailSidepanel
